module.exports = __webpack_public_path__ + "img/Icon3.3774cd3f.webp";